import * as React from "react";

import { AiOutlineLoading3Quarters } from "react-icons/ai";

interface SpinnerProps {
    size?: string;
    className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = "18px", className }) => {
    return (
        <AiOutlineLoading3Quarters
            size={size}
            className={`animate-spin duration-500 ${className}`}
        />
        // <Spin
        //     indicator={<AiOutlineLoading3Quarters className={`animate-spin duration-500`} />}
        //     size="small"
        // />
    );
};

export default Spinner;
